import React from 'react'
import { useTranslation } from 'i18n'

import CopyToClipboardButton from './CopyToClipboardButton'
import OptionalDropdownButton from './OptionalDropdownButton'
import ResultCard from './ResultCard'

import './ResultCardPanel.scss'

export const ResultCardPanel = ({
  title,
  detail,
  items,
  dropdownButtons = [],
  onCardClick = function (id, url) {},
  onLinkClick = function (id, url) {},
  shareIcons = null,
  onClipboardCopy = function () {},
}) => {
  const { t } = useTranslation('grocery')
  const itemTextOnlyArr = items.map(item => {
    return item.label.replace(/<[^>]*>/g, '')
  })
  const textToCopy = itemTextOnlyArr.join(', ')
  return (
    <div className={`grocery-result-card-panel`}>
      {title && (
        <h2
          className="step-content__title"
          dangerouslySetInnerHTML={{ __html: title }}
        />
      )}

      {detail && (
        <div
          className={`detail`}
          dangerouslySetInnerHTML={{ __html: detail }}
        />
      )}

      {items && (
        <div className={`grocery-result-cards`}>
          {items.map((item, i) => {
            return (
              <ResultCard
                id={item.id}
                key={i}
                url={item.url}
                label={item.label}
                imageUrl={
                  item.image
                    ? `${process.env.SITE_ASSET_URL}/${item.image.id}`
                    : null
                }
                buttonText={item.buttonCopy}
                onClick={onCardClick}
              />
            )
          })}
        </div>
      )}

      <div className={`columns`}>
        <div className={`col cta`}>
          {dropdownButtons && (
            <div className="result-multibuttons">
              {dropdownButtons.map((dropdownButton, i) => {
                return (
                  <OptionalDropdownButton
                    key={i}
                    id={dropdownButton.id}
                    label={dropdownButton.buttonCopy}
                    links={dropdownButton.links}
                    onLinkClick={onLinkClick}
                  />
                )
              })}
            </div>
          )}

          <CopyToClipboardButton
            id="copy"
            label={t('copyListToClipboard')}
            textToCopy={textToCopy}
            onClick={onClipboardCopy}
          />

          {shareIcons}
        </div>
      </div>
    </div>
  )
}

export default ResultCardPanel
